// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Cet élément regroupe :\n\n- le partenaire à l'origine de l'offre d'emploi\n- l'identifiant unique de l'offre d'emploi au sein du système d'information La bonne alternance\n"
export default markdown
